import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { TripScreen, type TripTab } from '@/features/trips/TripScreen.tsx';
import { requireAuth } from '@/features/auth/guard.ts';
import { q } from '@/lib/queries.ts';

const TABS: TripTab[] = ['overview', 'tickets', 'itinerary', 'map', 'budget'];

export const Route = createFileRoute('/_app/trips/$tripId')({
  validateSearch: (s: Record<string, unknown>): { tab?: TripTab; fresh?: string } => ({
    ...(TABS.includes(s.tab as TripTab) ? { tab: s.tab as TripTab } : {}),
    ...(typeof s.fresh === 'string' ? { fresh: s.fresh } : {}),
  }),
  beforeLoad: requireAuth,
  loader: ({ context, params }) => context.queryClient.prefetchQuery(q.trip(params.tripId)),
  component: TripRoute,
});

function TripRoute() {
  const { tripId } = Route.useParams();
  const { tab = 'overview', fresh } = Route.useSearch();
  const navigate = useNavigate();
  return <TripScreen tripId={tripId} tab={tab} fresh={fresh === '1'} onTab={(t) => void navigate({ to: '/trips/$tripId', params: { tripId }, search: { tab: t }, replace: true })} />;
}
